<!-- pc端 邀请用户 -->
<template>
  <div class="administrator">
    <!-- 头部步骤条 -->

    <div class="top_Steps">
      <div class="Steps_one">
        <span class="one_num" :class="active >= 1 ? 'activation' : ''">01</span>
        手机号填写
        <span class="one_bg" :class="active >= 1 ? 'bg_activation' : ''"></span>
      </div>
      <div class="Steps_one">
        <span class="one_num" :class="active >= 2 ? 'activation' : ''">02</span>
        账号信息填写
        <span class="one_bg" :class="active >= 2 ? 'bg_activation' : ''"></span>
      </div>
      <div class="Steps_one">
        <span class="one_num" :class="active >= 3 ? 'activation' : ''">03</span>
        加入公司成功
        <span class="one_bg" :class="active >= 3 ? 'bg_activation' : ''"></span>
      </div>
    </div>

    <!-- 中部表格 -->

    <div class="bottom_stept">
      <div v-if="active == 1" class="center_card">
        <div class="LoginPhone">
          <div class="center">{{ companyname }}</div>
          <div class="input">
            <div class="input_name">
              <span class="Required">*</span>手机号填写
            </div>
            <el-input
              v-model="phonenumber"
              placeholder="必填"
              @input="phonenumberinputChange"
            ></el-input>
          </div>
          <div class="input">
            <div class="input_name"><span class="Required">*</span>验证码</div>
            <el-input v-model="pohoneCode" placeholder="必填" class="name_getcode">
              <template slot="append">
                <div class="input_name_in" @click="getCode" v-if="!count">
                  获取验证码
                </div>
                <div class="input_name_in" v-if="count">
                  {{ count }}秒后重发
                </div>
              </template>
            </el-input>
          </div>
          <div class="login_button">
            <div
              class="button"
              @click="nexType(1)"
              v-if="pohoneCode && phonenumber"
            >
              下一步
            </div>
            <div class="button_no" v-if="!pohoneCode || !phonenumber">
              下一步
            </div>
          </div>
        </div>
      </div>

      <div v-if="active == 2" class="center_card">
        <div class="LoginPhone">
          <div class="center">{{ companyname }}</div>
          <div class="input">
            <div class="input_name"><span class="Required">*</span>姓名</div>
            <el-input
              v-model="userName"
              placeholder="请输入真实姓名"
            ></el-input>
          </div>
          <div class="input">
            <div class="input_name">账号</div>
            <el-input v-model="account" placeholder="请输入账号"></el-input>
          </div>
          <div class="input">
            <div class="input_name"><span class="Required">*</span>密码</div>
            <el-input v-model="passworld" placeholder="请输入密码"></el-input>
          </div>
          <div class="input">
            <div class="input_name">身份证号</div>
            <el-input v-model="idCard" placeholder="请输入身份证号"></el-input>
          </div>
          <!-- <div class="erro">*您输入的账号不存在或验证码错误</div> -->

          <div class="login_button">
            <div class="button" @click="active--">上一步</div>
            <div
              class="button"
              @click="nexType(2)"
              v-if="userName && passworld"
            >
              下一步
            </div>
            <div class="button_no" v-if="!userName || !passworld">下一步</div>
          </div>
        </div>
      </div>

      <div v-if="active == 3" class="center_card">
        <div class="LoginPhone">
          <div class="suss_msg">您已注册成功！</div>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import {
  phoneverifyCode,
  usercheckPhone,
  createUserOrCompany
} from "../../../api/api";
import { checkPhone, checkIdcardPattern } from '@/utils/tools';
export default {
  name: "memberPc",
  props: ["companyname", "deptId", "createBy", 'info'],
  components: {},
  data() {
    return {
      phonenumber: "", //手机号
      pohoneCode: "", //验证码
      userName: "", //用户名
      account: "", //账号
      passworld: "", //密码
      idCard: '', // 身份证号码
      timer: null,
      count: null,
      active: 1,
    };
  },

  methods: {
    /**
     * 点击获取验证码
     * */

    getCode() {
      if (checkPhone(this.phonenumber)) {
        let params = {
          phone: this.phonenumber,
          type: "Register",
        };
        phoneverifyCode(params).then((res) => {
          if (res.code == 200) {
            this.countdown();
          }
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: "手机号输入有误，请重新输入！",
        });
      }
    },

    /**
     * 60秒倒计时，验证码请求成功后开始
     * */

    countdown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count -= 1;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    /**
     * 电话号码输入只能输入数字
     * */
    phonenumberinputChange(val) {
      this.phonenumber = this.phonenumber.replace(/[^0-9.]/g, "");
    },

    /**
     * 点击下一步
     * */

    nexType(data) {
      if (data == 1) {
        let params = {
          phone: this.phonenumber,
          code: this.pohoneCode,
          deptId: this.$props.deptId,
        };
        usercheckPhone(params).then((res) => {
          if (res.data == 1) {
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
            this.active = data + 1;
          } else if (res.data == 2) {
            this.active = 3;
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
          } else if (res.code == 6006) {
            this.$notify.error({
              title: "错误",
              message: res.msg,
            });
          }
        });
      } else if (data == 2) {
        if (this.idCard && !checkIdcardPattern(this.idCard)) {
          this.$notify.error({
            title: "错误",
            message: "请输入正确的身份证号码！",
          })
          return
        }
        let params = {
          companyName: this.companyname,
          userName: this.account,
          nickName: this.userName,
          phone: this.phonenumber,
          password: this.passworld,
          idCard: this.idCard,
          createBy: this.createBy,
          deptId: this.deptId,
          ...this.info
        };
        createUserOrCompany(params).then((res) => {
          if (res.code == 200) {
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
            this.active = data + 1;
          } else {
            this.$notify.error({
              title: "失败",
              message: res.msg,
            });
          }
        });
      } else {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.administrator {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .top_Steps {
    width: 55rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    user-select: none;
    .Steps_one {
      width: 18.75rem;
      position: relative;
      font-weight: 400;
      font-size: 1.25rem;
      line-height: 1.75rem;
      color: #3e3a39;
      .one_num {
        font-style: normal;
        font-weight: 400;
        font-size: 2rem;
        line-height: 2.8125rem;
        color: #cccccc;
      }
      .activation {
        font-weight: 600;
        color: #b7282d;
      }
      .one_bg {
        position: absolute;
        bottom: 0;
        left: -0.5rem;
        width: 12.5rem;
        height: 1.25rem;
        background: linear-gradient(
          90deg,
          rgba(204, 204, 204, 0.3) 0%,
          rgba(183, 40, 45, 0.018) 99.4%
        );
        border-radius: 1rem;
      }

      .bg_activation {
        background: linear-gradient(
          90deg,
          rgba(183, 40, 45, 0.3) 0%,
          rgba(183, 40, 45, 0.018) 99.4%
        );
      }
    }
  }

  .LoginPhone :deep(.el-input-group__append, .el-input-group__prepend) {
    background-color: #fff !important;
    color: #b7282d;
  }

  .LoginPhone
    :deep(.el-input-group__append:focus, .el-input-group__prepend:focus) {
    user-select: none !important;
    cursor: pointer !important;
  }

  .bottom_stept {
    margin-top: 1.5rem;
    margin-bottom: 6.25rem;
    width: 55rem;
    height: 28.75rem;
    background: #ffffff;
    box-shadow: 0.375rem 0.375rem 0.75rem 0.125rem rgba(0, 0, 0, 0.16),
      -0.375rem -0.375rem 0.75rem 0.125rem rgba(0, 0, 0, 0.16);
    border-radius: 1rem;
    background-image: url("../../../assets/IMG/login/bg_ele.png");
    background-repeat: no-repeat;
    background-position: right 0rem bottom 0rem;
    .center_card {
      z-index: 10;
      height: 100%;
      padding: 1.25rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      .LoginPhone {
        width: 35%;
        .center {
          font-weight: 600;
          width: 100%;
          text-align: center;
          margin-bottom: 3.125rem;
        }
        .title {
          font-weight: 400;
          font-size: 1.25rem;
          line-height: 1.75rem;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 3.75rem;
        }
        .input {
          position: relative;
          padding: 1.25rem 0 0.625rem 0;
          .input_name {
            z-index: 5;
            position: absolute;
            color: #999999;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.375rem;
            background: #fff;
            left: 5%;
            top: 0.375rem;
          }

          .input_name_in {
            width: 100%;
            height: 100%;
            user-select: none;
            cursor: pointer;
          }
        }

        .erro {
          user-select: none;
          font-weight: 400;
          font-size: 0.75rem;
          line-height: 1.0625rem;
          color: #f84638;
        }

        .login_button {
          user-select: none;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 3.75rem;

          .button {
            margin-right: 10px;
            cursor: pointer;
            width: 4rem;
            height: 2rem;
            background: #b7282d;
            border-radius: 0.25rem;
            color: #ffffff;
            font-size: 0.75rem;
            line-height: 1.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .button_no {
            cursor: pointer;
            width: 4rem;
            height: 2rem;
            background: #ccc;
            border-radius: 0.25rem;
            color: #ffffff;
            font-size: 0.75rem;
            line-height: 1.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .suss_msg {
          text-align: center;
          font-weight: 400;
          font-size: 1.625rem;
          line-height: 2.25rem;
          color: #333333;
        }
        .avatar-uploader {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .avatar-uploader .el-upload {
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader-icon {
          font-size: 1.75rem;
          color: #8c939d;
          width: 5.5rem;
          height: 5.5rem;
          line-height: 5.5rem;
          text-align: center;
          border: 0.0625rem dashed #ccc;
          border-radius: 0.375rem;
        }
        .avatar {
          width: 5.5rem;
          height: 5.5rem;
          display: block;
        }
      }
    }
  }
}
</style>